import { modalCloseCrossIcon } from '@porterin/feature/src/ui/assets/AssetStore';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import React from 'react';

import styles from '../styles/PnMFareEstimateModalLayout.module.scss';

interface PnMFareEstimateModalLayoutCmpProps {
  title: string;
  sub_title: string;
  title_mobile: string;
  children: React.ReactNode;
  close_modal: () => void;
}

function PnMFareEstimateModalLayoutCmp({
  title,
  sub_title,
  title_mobile,
  children,
  close_modal,
}: Readonly<PnMFareEstimateModalLayoutCmpProps>): React.ReactElement {
  return (
    <div className={styles['estimate-layout-container']}>
      <section className={styles['title-container']}>
        <p className={styles['title']}>{title}</p>
        <p className={styles['sub-title']}>{sub_title}</p>
        <p className={styles['title-mobile']}>{title_mobile}</p>
      </section>
      <section className={styles['form-container']}>{children}</section>
      <button className={styles['close-modal-button']} onClick={close_modal}>
        <NextImageV2
          src={modalCloseCrossIcon}
          height={24}
          width={24}
          alt="close"
          quality={100}
        />
      </button>
    </div>
  );
}

export default PnMFareEstimateModalLayoutCmp;
